import React from 'react'
import { ClickAwayListener, Fade, Popper } from '@mui/material'
import { track } from '@SonarCX/lib/mixpanel'

import TagV2 from '@SonarCX/components/molecules/EHAccordion/TagBlockV2/TagV2'

import useStyles from './styles'

interface TagsPreviewModalProps {
  tags: string[]
  onClose: () => void
  parentRef: any
  shouldCheckClose: boolean
}

const TagsPreviewModal: React.FC<TagsPreviewModalProps> = ({
  tags = [],
  onClose,
  parentRef,
  shouldCheckClose
}) => {
  const [hasBeenHovered, setHasBeenHovered] = React.useState(false)

  const classes = useStyles()

  const handleMouseEnter = React.useCallback(() => {
    setHasBeenHovered(true)
  }, [])

  const handleMouseLeave = React.useCallback(() => {
    if (hasBeenHovered) {
      onClose()
    }
  }, [hasBeenHovered, onClose])

  React.useEffect(() => {
    track('TAG_PREVIEW_OPENED')
  }, [])

  React.useEffect(() => {
    if (shouldCheckClose) {
      if (!hasBeenHovered) {
        onClose()
      }
    }
  }, [shouldCheckClose, hasBeenHovered, onClose])

  return (
    <ClickAwayListener onClickAway={onClose}>
      <Popper
        open
        anchorEl={parentRef?.current}
        style={{ zIndex: '1299' }}
        placement='right'
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps}>
            <div
              className={classes.root}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <div className={classes.tagsContainer}>
                {tags.map((tag, index) => (
                  <TagV2 key={`cell-tag-${tag}-${index}`} hideIcon tag={tag} />
                ))}
              </div>
            </div>
          </Fade>
        )}
      </Popper>
    </ClickAwayListener>
  )
}

export default TagsPreviewModal
